import React, { type ReactNode } from 'react';
import { toast } from 'sonner';

import { Toast } from '../toaster/Toast';

const useToaster = () => {
  const addWarningToast = (content: ReactNode, duration = 80000) => {
    return toast.custom(() => <Toast description={content} type="warning" />, { duration });
  };
  const addErrorToast = (content: ReactNode, duration = 8000) => {
    return toast.custom(() => <Toast description={content} type="error" />, { duration });
  };
  const addInfoToast = (content: ReactNode, duration = 8000) => {
    return toast.custom(() => <Toast description={content} type="info" />, { duration });
  };
  const addSuccessToast = (content: ReactNode, duration = 8000) => {
    return toast.custom(() => <Toast description={content} type="success" />, { duration });
  };

  return {
    addWarningToast,
    addErrorToast,
    addInfoToast,
    addSuccessToast,
  };
};

export default useToaster;
